import { ExternalLink } from "lucide-react";
import { useState } from "react";

import { getLinkPreviewIcon } from "../link-preview-utils";

import type { LinkPayload } from "@/routes/smart-table/utils/contentType";

interface LinkCellPreviewProps {
  link: LinkPayload;
  openDialog?: () => void;
}

export default function LinkCellPreview({ link, openDialog }: LinkCellPreviewProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const Icon = getLinkPreviewIcon(link.kind);
  const shouldShowImagePreview = link.kind === "image" && !imageFailed;

  return (
    <div className="flex h-full w-full items-center justify-center px-1">
      <button
        type="button"
        className="group flex h-7 w-auto max-w-full cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-md bg-muted/60 px-2.5 transition-colors hover:bg-muted/80"
        onClick={event => {
          event.stopPropagation();
          openDialog?.();
        }}
        onMouseDown={event => event.stopPropagation()}
        onPointerDown={event => event.stopPropagation()}
        onDoubleClick={event => event.stopPropagation()}
        title={link.url}
      >
        <div className="flex flex-shrink-0 items-center justify-center text-muted-foreground/80 group-hover:text-foreground">
          {shouldShowImagePreview ? (
            <img
              src={link.url}
              alt=""
              loading="lazy"
              decoding="async"
              className="h-4 w-4 rounded-sm border border-border/50 object-cover"
              onError={() => setImageFailed(true)}
            />
          ) : (
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
          )}
        </div>
        <span className="min-w-0 truncate text-[13px] font-medium text-foreground/80 group-hover:text-foreground">
          {link.label}
        </span>
        <ExternalLink
          className="h-3 w-3 flex-shrink-0 text-muted-foreground/60 opacity-0 transition-opacity group-hover:opacity-100"
          aria-hidden="true"
        />
      </button>
    </div>
  );
}
